App.directive('formAssuredPersonTpl', ['$window', 'Config', '$filter', 'statesService', '$q',
    function ($window, Config, $filter, statesService, $q) {
    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            model: '=',
            prefix: '@',
            withSibling: '=',
            forWorker: '=?',
            copyAddress: '=?',
            person: '=?',
            key: '='
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/form-assured-person-tpl.html',
        link: function(scope) {
    	    scope.copyAddress = scope.copyAddress || false;
    	    scope.person = scope.person || null;
    	    // scope.differentAddress = true;
    	    scope.showCheckbox = false;

            // (function () {
            //     var isLogged = window.sessionStorage.getItem('isLogged');
            //     if (scope.copyAddress && isLogged) {
            //         // scope.differentAddress = false;
            //         scope.showCheckbox = true;
            //         var userObject = angular.fromJson(window.sessionStorage.getItem('userObject'));
            //         scope.model.city = userObject.person.address.city;
            //         scope.model.street = userObject.person.address.street;
            //         scope.model.number = userObject.person.address.number;
            //         scope.model.apartment = userObject.person.address.apartment;
            //         scope.model.zipCode = userObject.person.address.zipCode;
            //     }
            // })();

            var getResults = function(query) {
                var deferred = $q.defer();

                statesService.dataCityLists({
                    name: query
                }).then(function(data) {
                    deferred.resolve(data.data);
                });

                return deferred.promise;
            };

            // ##### LOCALIZATION FILTER ##### //
            scope.querySearchLocalization = function(query) {
                if (!query) {
                    return;
                }
                  
                return getResults(query).then(function(results) {
                    return results;
                });
            };

            var unwatch = null;

            startWatcher();
            scope.toggleDifferentAddress = function () {
                if (!scope.differentAddress) {
                    startWatcher();
                } else {
                    unwatch && unwatch();
                }
            };

            function startWatcher() {
                if (scope.person) {
                    unwatch = scope.$watch('person', function () {
                        scope.model.city = scope.person.address.city;
                        scope.model.street = scope.person.address.street;
                        scope.model.number = scope.person.address.number;
                        scope.model.apartment = scope.person.address.apartment;
                        scope.model.zipCode = scope.person.address.zipCode;
                    }, true);
                }
            }
        }
    };
}]);